import { createEmptyAction, createMapAction } from "chalet-shared";

import { Data, RoomMeta } from "../service/Data";

export const actionCreators = {
    epicEnd: createEmptyAction("END"),
    appIsReady: createEmptyAction("APP_IS_READY"),

    onWrongToken: createEmptyAction("ON_WRONG_TOKEN"),
    setProtoToken: createMapAction("SET_PROTO_TOKEN", (x: { token: string | undefined }) => x),

    onSync: createMapAction("ON_SYNC", (x: Data.HelloIn) => x),
    //
    onOnline: createMapAction("ON_ONLINE", (x: Data.HelloIn) => x),
    onOffline: createMapAction("ON_OFFLINE", (x: { goingToReconnect: boolean }) => x),
    onDiscover: createMapAction("ON_DISCOVER", (x: Data.Discover | undefined) => x),
    //
    onRoster: createMapAction("ON_ROSTER", (x: { data: Data.RoomsIn; unsolicited?: boolean }) => x),
    //
    onReceipts: createMapAction("ON_RECEIPTS", (x: Data.ReceiptsIn) => x),
    setReceiptsEnqueued: createMapAction(
        "SET_RECEIPTS_ENQUEUED",
        (x: { roomId: string; ts: number; monologUserId: string }) => x
    ),
    setReceiptsStarted: createMapAction(
        "SET_RECEIPTS_STARTED",
        (x: { roomId: string; ts: number }) => x
    ),
    setReceiptsSucceeded: createMapAction("SET_RECEIPTS_SUCCEEDED", (x: { roomId: string }) => x),
    setReceiptsFailed: createMapAction("SET_RECEIPTS_FAILED", (x: { roomId: string }) => x),
    //
    onRoomMeta: createMapAction("ON_ROOM_META", (x: Data.MetaIn<RoomMeta>) => x),
    //
    onNotify: createMapAction("ON_NOTIFY", (x: { data: Data.NotifyIn; ignore: boolean }) => x),
    onLogout: createMapAction(
        "ON_LOGOUT",
        (x: { token?: string; isCustomEnvironment: boolean }) => x
    ),
    onTyping: createMapAction("ON_TYPING", (x: Data.TypingIn) => x),
    onRoomText: createMapAction(
        "ON_ROOM_TEXT",
        (x: { data: Data.RoomTextIn; pendingId?: string }) => x
    ),
    onUpdateRoomText: createMapAction(
        "ON_UPDATE_ROOM_TEXT",
        (x: { data: Data.UpdateRoomTextIn }) => x
    ),
    onDeleteRoomText: createMapAction(
        "ON_DELETE_ROOM_TEXT",
        (x: { data: Data.DeleteRoomTextIn }) => x
    ),
    onReactionUpdate: createMapAction(
        "ON_REACTION_UPDATE",
        (x: { data: Data.ReactionIn }) => x
    ),
    onSeenText: createMapAction("ON_SEEN_TEXT", (x: Data.SeenText) => x),
    onSeenAllText: createMapAction("ON_SEEN_ALL_TEXT", (x: Data.SeenAllText) => x),
    onUnseenText: createMapAction("ON_UNSEEN_TEXT", (x: Data.MarkTextUnseen) => x),
    //
    ensureUsersLoadedRequested: createMapAction(
        "ENSURE_USERS_LOADED_REQUESTED",
        (x: { userIds: string[]; tag: string }) => x
    ),
    ensureUsersLoadedStarted: createMapAction(
        "ENSURE_USERS_LOADED_STARTED",
        (x: { userIds: string[]; tag: string }) => x
    ),
    ensureUsersLoadedSucceeded: createMapAction(
        "ENSURE_USERS_LOADED_SUCCEEDED",
        (x: { userIds: string[] }) => x
    ),
    ensureUsersLoadedFailed: createMapAction(
        "ENSURE_USERS_LOADED_FAILED",
        (x: { userIds: string[] }) => x
    ),
    //
    ensureRoomsLoadedRequested: createMapAction(
        "ENSURE_ROOMS_LOADED_REQUESTED",
        (x: { roomIds: string[]; tag: string }) => x
    ),
    ensureRoomsLoadedStarted: createMapAction(
        "ENSURE_ROOMS_LOADED_STARTED",
        (x: { roomIds: string[]; tag: string }) => x
    ),
    ensureRoomsLoadedSucceeded: createMapAction(
        "ENSURE_ROOMS_LOADED_SUCCEEDED",
        (x: { roomIds: string[] }) => x
    ),
    ensureRoomsLoadedFailed: createMapAction(
        "ENSURE_ROOMS_LOADED_FAILED",
        (x: { roomIds: string[] }) => x
    ),
    //
    setForumLevelStarted: createMapAction(
        "SET_FORUM_LEVEL_STARTED",
        (x: { forumId: string; level: Data.Level }) => x
    ),
};
